export default (size) => {
    size = String(size);
    let convertedSize = parseFloat(size); 
    if (size.indexOf('px') !== -1 || size.match(/^\s*\d+(\.\d+)*\s*$/)) {
        convertedSize *= 0.75;
    } else if (size.indexOf('mm') !== -1) {
        convertedSize *= 72;
        convertedSize /= 25.4;
    } else if (size.indexOf('cm') !== -1) {
        convertedSize *= 72;
        convertedSize /= 2.54;
    } else if (size.indexOf('in') !== -1) {
        convertedSize *= 72;
    } else if (size.indexOf('pc') !== -1) {
        convertedSize *= 12;
    }
    return convertedSize;
}